import { Injectable } from '@angular/core';
import { FlightSearchResult } from '../interface/flight-search-result';
import { Router } from '@angular/router';
import { resetSelectedFlight } from '../store/flight-search/flight-search.actions';
import { Store } from '@ngrx/store';
import { SearchFlightModule } from '../models/search-flight/search-flight.module';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class FlightServiceService {
  lastSearchModule : SearchFlightModule = JSON.parse(localStorage.getItem('lastSearchModule')) || undefined;

  response: FlightSearchResult;
  serachId: string;
  fSelect:boolean = false;
  sequenceNumber: number[] = [];
  providerKey: string;
  flightsInfo: string;
  multiCitySearch : boolean ;
  OpenDiv : boolean = false;
  Select: boolean = true;
  public flightTypeInSearchBox = 'RoundTrip'
public SelectOneFlight = false;
  constructor(
    private router: Router,
    private translate: TranslateService,
    private readonly store : Store) { }


    
  // getDepartueCity&& departueCountry
  departureCity() {
    // item[0].allJourney.flights[0].flightDTO[0].departureTerminalAirport.cityName
    let city: string = this.response.airItineraries[0].allJourney.flights[0].flightDTO[0].departureTerminalAirport.cityName;
    let country: string = this.response.airItineraries[0].allJourney.flights[0].flightDTO[0].departureTerminalAirport.countryName;
    return city + "," + country;
  }
  // getlanding in oneway 
  landingCity() {
    // airItineraries[""0""].allJourney.flights[""0""].flightDTO[""0""].arrivalTerminalAirport

    let city: string = "";
    let country: string = '';
    // check if stops more than one
    let stops = this.response.airItineraries[0].allJourney.flights[0].stopsNum;

    if (stops > 0) {
      let flength = this.response.airItineraries[0].allJourney.flights[0].flightDTO.length;
      city = this.response.airItineraries[0].allJourney.flights[0].flightDTO[flength - 1].arrivalTerminalAirport.cityName;
      country = this.response.airItineraries[0].allJourney.flights[0].flightDTO[flength - 1].arrivalTerminalAirport.countryName;

    }
    else {
      city = this.response.airItineraries[0].allJourney.flights[0].flightDTO[0].arrivalTerminalAirport.cityName;
      country = this.response.airItineraries[0].allJourney.flights[0].flightDTO[0].arrivalTerminalAirport.countryName;
    }
    return city + "," + country;
  }

  // get depatrure in oneway 
  getDepartueDate() {


    let flight = this.flightsInfo.split("-");
    let departure = flight[2];
    return departure;
  }



  // Round Trip  //
  arrivalCity(item: any, flightN: number) {
    let ar: [] = item.allJourney.flights[flightN]["flightDTO"];
    let m: number = ar.length;
    let i: number = m - 1
    return item.allJourney.flights[flightN].flightDTO[i]["arrivalTerminalAirport"]["cityName"];
  }

  arrivalAircode(item: any, flightN: number) {
    let ar: [] = item.allJourney.flights[flightN]["flightDTO"];
    let m: number = ar.length;
    let i: number = m - 1
    return item.allJourney.flights[flightN].flightDTO[i]["arrivalTerminalAirport"]["airportCode"];
  }
  arrivalAirName(item: any, flightN: number) {
    let ar: [] = item.allJourney.flights[flightN]["flightDTO"];
    let m: number = ar.length;
    let i: number = m - 1
    return item.allJourney.flights[flightN].flightDTO[i]["arrivalTerminalAirport"]["airportName"];
  }
  arrivalDate(item: any, flightN: number) {
    let ar: [] = item.allJourney.flights[flightN]["flightDTO"];
    let m: number = ar.length;
    let i: number = m - 1
    return item.allJourney.flights[flightN].flightDTO[i]['arrivalDate'];
  }

  arrivalStopCity(item: any, flightN: number) {
    let ar: [] = item.allJourney.flights[flightN]["flightDTO"];
    let m: number = ar.length;
    let i: number = 0
    for (i; i < m - 1; i++) {
      return item.allJourney.flights[flightN].flightDTO[i]["arrivalTerminalAirport"]["cityName"];
    }

  }
  arrivalStopAirPort(item: any, flightN: number) {
    let ar: [] = item.allJourney.flights[flightN]["flightDTO"];
    let m: number = ar.length;
    let i: number = 0
    for (i; i < m - 1; i++) {
      return item.allJourney.flights[flightN].flightDTO[i]["arrivalTerminalAirport"]["airportName"];
    }

  }
  arrivalStopAircode(item: any, flightN: number) {
    let ar: [] = item.allJourney.flights[flightN]["flightDTO"];
    let m: number = ar.length;
    let i: number = 0;
    for (i; i < m - 1; i++) {
      return item.allJourney.flights[flightN].flightDTO[i]["arrivalTerminalAirport"]["airportCode"];
    }
  }

  arrivalStopDate(item: any, flightN: number) {
    let ar: [] = item.allJourney.flights[flightN]["flightDTO"];
    let m: number = ar.length;
    let i: number = 0
    for (i; i < m - 1; i++) {
      return item.allJourney.flights[flightN].flightDTO[i]['arrivalDate'];
    }
  }

  direct(item: any) {
    if (item == 0) {
      return 'Direct';
    }
    else {
      return item + 'Stops ';
    }

  }


  showStopStation(item: any, flightN: number) {
    let stopArr: [] = [];
    let ar: [] = item.allJourney.flights[flightN]["flightDTO"];
    let m: number = ar.length;
    let i: number = 0;
    for (i; i < m; i++) {
      stopArr.push(ar[i]);
    }
    return stopArr;


  }

  fillSequenceArr() {

    for (let i = 0; i < this.response.airItineraries.length; i++) {
      this.sequenceNumber.push(this.response.airItineraries[i].sequenceNum);

    }

  }

  // route to check out
  toCheckout(sid: string, sequenceNum: number, providerKey: string |number,pcc:string,brandId?:string) {
    this.store.dispatch(resetSelectedFlight()); 
    this.router.navigate(['/checkout',this.translate.currentLang], { queryParams: { 'sid': sid+'_'+pcc, 'sequenceNum': sequenceNum, 'providerKey': providerKey ,'brandId':brandId} });
  }

  // fareRulesbtn
  valuesoftrue(array: any[]) {
    let out: any[] = [];
    let arryalengty = array.length;
    for (let index = 0; index < arryalengty; index++) {
      let truth: boolean = true;
      out.push(truth);

    }
    return out;
  }

}
